import { Link, Outlet } from '@tanstack/react-router';
import { useMe } from '../lib/account';
import { LegalGate } from './LegalGate';
import styles from './AppShell.module.css';

export const navigation = [
  { to: '/', label: 'Inicio' },
  { to: '/playground', label: 'Playground' },
  { to: '/historial', label: 'Historial' },
  { to: '/asistentes', label: 'Asistentes' },
  { to: '/biblioteca', label: 'Biblioteca' },
  { to: '/cuenta', label: 'Cuenta' },
] as const;

/** Roles con acceso a la administración. El servidor decide; esto solo enseña el enlace. */
const ADMIN_ROLES = new Set(['admin', 'support']);

export function AppShell() {
  const me = useMe();
  const isStaff = me.data?.access.roles.some((role) => ADMIN_ROLES.has(role)) ?? false;
  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <img
          className={styles.logo}
          src="/brand/ailab-logo.svg"
          alt="AILAB"
          width={120}
          height={35}
        />
        <nav className={styles.nav} aria-label="Navegación principal">
          {navigation.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={styles.link}
              activeProps={{ className: `${styles.link} ${styles.active}`, 'aria-current': 'page' }}
              activeOptions={{ exact: item.to === '/' }}
            >
              {item.label}
            </Link>
          ))}
          {isStaff ? (
            <Link
              to="/admin/usuarios"
              className={styles.link}
              activeProps={{ className: `${styles.link} ${styles.active}`, 'aria-current': 'page' }}
            >
              Administración
            </Link>
          ) : null}
        </nav>
      </aside>
      <main className={styles.main}>
        <LegalGate />
        <Outlet />
      </main>
    </div>
  );
}
